// Feature component for assigning a bike to a case

interface AssignBikeProps {
  caseId: string;
  onSuccess?: () => void;
  onCancel?: () => void;
}

export function AssignBike({ onSuccess }: AssignBikeProps) {
  const handleAssignBike = async () => {
    try {
      // This would typically open a modal to assign a bike to the case
      // For now, we'll just trigger the AssignBikeModal from the parent component
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Error assigning bike:', error);
    }
  };

  return (
    <button 
      onClick={handleAssignBike}
      className="flex items-center gap-1 text-indigo-600 hover:text-indigo-800 px-3 py-2 rounded-md hover:bg-indigo-50 border border-indigo-200"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
      <span>Assign Bike</span>
    </button>
  );
}
